import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { AtsUpdateJobPostingStatusDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { EventTypes, dispatch } from 'modules/core/lib/pubSub'
import app from 'modules/core/store/models/app'

interface Props {
  careersUrl: string
  id: number
  onClose: () => void
}

export const CancelJobPostingModal = ({ onClose, careersUrl, id }: Props) => {
  const [update] = useMutation(AtsUpdateJobPostingStatusDocument, {
    extractorFn: (data) => data.atsMutations.updateAtsJobPosting,
  })

  const onSubmit = async () => {
    const result = await update({
      variables: {
        id,
        status: 'cancelled',
      },
    })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })

      dispatch({
        type: EventTypes.JOB_POSTING_STATUS_CHANGED,
      })

      onClose()
    }

    return handled
  }

  return (
    <Modal
      title={i18n.t('ats.job_details.confirm_cancel.title')}
      description={i18n.tView('ats.job_details.confirm_cancel.description', {
        careers_page_link: (
          <a rel="nofollow noopener noreferrer" target="_blank" href={careersUrl}>
            {i18n.t('ats.job_details.confirm_cancel.careers_page_link')}
          </a>
        ),
      })}
      illustration="input-field"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button type="negative" submit>
          {i18n.t('ats.job_details.cancel_job')}
        </Button>
      }
    />
  )
}
